<template>
  <div>
    <section class="merchants-bg">
      <div class="container shape-container pt-md-5">
        <div class="pt-md-5">
          <div class="col-lg-8 pt-5">
            <div class="row pt-5">
              <h3 class="display-3 mt-5 text-uppercase">
                Are you a merchant, <br />reseller or a dealer?
                <span class=""
                  >Send airtime, data and credits <br />to your staff and
                  customers</span
                >
              </h3>
              <p class="lead text-dark mt-0">
                Doing business with your TopupBox just <br />
                got better, easier and faster.
              </p>
            </div>
          </div>
        </div>

        <div class="btn-wrapper">
          <a href="https://topupcliq.com/register" class="btn btn-info">
            Sign up now
          </a>
        </div>
      </div>
    </section>

    <section class="section px-lg-0 px-4">
      <div class="container">
        <div class="row row-grid align-items-center pb-md-5">
          <div
            class="col-md-6 order-md-2"
            data-aos="fade-left"
            data-aos-easing="ease-out-cubic"
            data-aos-duration="1000"
          >
            <div class="pl-md-5">
              <div class="mb-4">
                <img src="img/icons/common/enterprise.svg" class="img-fluid" />
              </div>
              <p>
                You can be the business in your environment, be the go to person
                in your vicinity. Get transactions done, recharge airtime and
                sell data. Make a great living out of our services
              </p>
              <p>
                TopUpBox gives a wide range of flexibility across its website,
                mobile app and ussd systems. <br />Easy to use, fast and
                reliable. <br />Get your business started.
              </p>
            </div>
          </div>
          <div class="col-md-6 order-md-1">
            <img
              src="img/theme/handshake.png"
              class="img-fluid rounded shadow-lg"
            />
          </div>
        </div>
      </div>
    </section>

    <section class="pb-5 px-lg-0 px-4">
      <div class="container">
        <div class="text-center justify-content-center">
          <div class="col-lg-12">
            <h2 class="display-3 text-default">Cases</h2>
            <p class="lead mb-5">
              Need to use TopupBox as a merchans? Here's how
            </p>
          </div>
        </div>
        <div class="row justify-content-center mb-4">
          <div class="col-lg-12">
            <div
              class="row row-grid"
              data-aos="fade-up"
              data-aos-easing="ease-out-cubic"
              data-aos-duration="1000"
            >
              <div class="col-lg-6">
                <card class="border-0" shadow body-classes="py-5">
                  <div class="row">
                    <div
                      class="col-3 d-flex justify-content-center align-items-center"
                    >
                      <div class="mb-4">
                        <img
                          src="img/icons/common/good.svg"
                          class="img-fluid"
                        />
                      </div>
                    </div>
                    <div class="col-9">
                      <h6 class="text-primary text-uppercase display-4">
                        Reselling
                      </h6>
                      <p class="description mt-3">
                        You can set up your custom page with our white label
                        technology to run transactions and Topups for your
                        customers. Resell all our services and get the business
                        running.
                      </p>
                    </div>
                  </div>
                </card>
              </div>
              <div class="col-lg-6">
                <card class="border-0" shadow body-classes="py-5">
                  <div class="row">
                    <div
                      class="col-3 d-flex justify-content-center align-items-center"
                    >
                      <div class="mb-4">
                        <img
                          src="img/icons/common/good.svg"
                          class="img-fluid"
                        />
                      </div>
                    </div>
                    <div class="col-9">
                      <h6 class="text-primary text-uppercase display-4">
                        Build with our API
                      </h6>
                      <p class="description mt-3">
                        you can consume our Api for your solutions to power your
                        website or mobile app. You can use this Api as a
                        business owner/ (using contracted developers) or as a
                        direct developer/tech outfits.
                      </p>
                    </div>
                  </div>
                </card>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {};
</script>

<style></style>
